// extracted by mini-css-extract-plugin
export var form = "_co-0";